/**
 *  用於關於頁面相關的變數
 */

// 聯絡我們人員列表
export const contact = [
  {
    name: '余鎧企',
    position: '負責人',
    mail: 'mcip.app@gmail.com',
    img: null,
  },
]

// 更新記錄列表
export const version = [
  {
    title: 'v1.8.1',
    date: '2026/01/07',
    items: [
      '新增 CSV 匯出「虛擬ATM帳號」欄位',
    ],
  },
  {
    title: 'v1.8.0',
    date: '2024/03/10',
    items: [
      '新增 CSV 篩選和排序匯出功能',
    ],
  },
  {
    title: 'v1.7.1',
    date: '2024/02/20',
    items: [
      '新增客語演唱組',
      '更新金流服務條款',
    ],
  },
  {
    title: 'v1.7.0',
    date: '2023/01/10',
    items: [
      '搬遷域名至 https://manage.mcip.app',
      '修正導覽列標題顯示',
    ],
  },
  {
    title: 'v1.6.2',
    date: '2021/11/1',
    items: [
      '修正底部工作列被全面屏裝置（如 iPhone X）橫條遮擋的問題',
      '修正 iOS 15 Safari 日期選擇器跳出多餘的原生選單的問題',
    ],
  },
  {
    title: 'v1.6.1',
    date: '2020/11/14',
    items: [
      '新增表單: 顯示「虛擬 ATM 帳號」欄位',
    ],
  },
  {
    title: 'v1.6',
    date: '2020/5/9',
    items: [
      '修改賽況: 手機版無法排序賽況',
      '更新識別 Logo',
    ],
  },
  {
    title: 'v1.5.3',
    date: '2020/3/31',
    items: [
      '新增表單: 顯示報名人之銀行代碼與帳號',
    ],
  },
  {
    title: 'v1.5.2',
    date: '2020/2/11',
    items: [
      '修改賽況: 多選行為',
      'UI 本地化 (Beta)',
    ],
  },
  {
    title: 'v1.5.1',
    date: '2019/12/21',
    items: [
      '新增畢業歌組',
    ],
  },
  {
    title: 'v1.5',
    date: '2019/12/8',
    items: [
      '修改設定: 調整 UI',
      '修改組別規則: 調整 UI',
      '新增組別規則: 可針對不同的組員人數調整報名費',
      '修改評語: 可上傳多張圖片',
    ],
  },
  {
    title: 'v1.4.5',
    date: '2019/11/14',
    items: [
      '新增設定/組別規則: 自定義欄位可設定為多行文字',
    ],
  },
  {
    title: 'v1.4.4',
    date: '2019/11/5',
    items: [
      '修正表單: 使用金流系統並已繳費的表單將無法刪除',
      '修改表單: 自定義欄位樣式',
    ],
  },
  {
    title: 'v1.4.3',
    date: '2019/10/22',
    items: [
      '新增表單: 手動設為已繳費功能',
    ],
  },
  {
    title: 'v1.4.2',
    date: '2019/9/9',
    items: [
      '修正表單: 學校名稱與電話號碼顯示',
    ],
  },
  {
    title: 'v1.4.1',
    date: '2019/8/29',
    items: [
      '新增設定: 帳務資訊相關欄位',
    ],
  },
  {
    title: 'v1.4.0',
    date: '2019/8/25',
    items: [
      '修改表單: 優化行動裝置表單列表介面，減少左右捲軸出現，並將翻頁工具列固定於頁面下方',
      '修改表單: 修正行動裝置匯出 CSV 功能與晉級表單排版',
      '修正評論: 當未填寫評語的任何欄位時，則按鈕的指示燈不會亮起',
    ],
  },
  {
    title: 'v1.3.8',
    date: '2019/8/24',
    items: [
      '修改表單: 調整報名者資料顯示樣式',
      '修改表單: 調整行動裝置選單樣式',
      '修改表單: 改進複製至剪貼簿功能',
    ],
  },
  {
    title: 'v1.3.7',
    date: '2019/8/23',
    items: [
      '修改表單: 組別為唯獨',
      '新增概況圖表: 報名時間',
      '新增概況: 下載圖表功能',
      '修改概況圖表樣式: 根據是否深色主題自動調整文字顏色',
    ],
  },
  {
    title: 'v1.3.6',
    date: '2019/8/22',
    items: [
      '新增概況: 賽制選項',
      '新增表單: 透過概況跳轉至表單頁時，顯示提示文字',
    ],
  },
  {
    title: 'v1.3.5',
    date: '2019/8/20',
    items: [
      '修改概況圖表樣式',
      '新增概況圖表: 繳費金額',
      '新增概況: 點擊圖表快速跳轉至表單列表頁面',
      '新增表單: 搜尋或篩選時顯示提示文字',
      '修正表單: 列表組別 tab 項目順序',
    ],
  },
  {
    title: 'v1.3.4',
    date: '2019/7/20',
    items: [
      '修改組別規則: 開放報名期間無法更改報名費用',
    ],
  },
  {
    title: 'v1.3.3',
    date: '2019/7/15',
    items: [
      '新增說唱組',
    ],
  },
  {
    title: 'v1.3.2',
    date: '2019/6/24',
    items: [
      '新增表單: 查看繳費狀態與資訊',
      '新增設定: 查看院校目前所選擇的繳費方案',
      '新增組別設定: 設定報名費',
    ],
  },
  {
    title: 'v1.3.1',
    date: '2019/5/7',
    items: [
      '新增 [偏好設定] 頁面',
      '新增偏好設定: 開啟搜尋框自動完成',
      '新增偏好設定: 開啟表單列表預設顯示筆數',
      '新增偏好設定: 使用思源黑體 (Noto Sans)',
      '移動深色主題開關至 [偏好設定] 頁面',
      '新增設定: 分類',
      '調整行動裝置瀏覽 [報名表單] 頁面與畫面的間距，以便顯示更多內容',
    ],
  },
  {
    title: 'v1.3.0',
    date: '2019/5/5',
    items: [
      '修改表單匯出CSV: 可匯出共通與自定義欄位',
      '修改匯出 CSV 頁面欄位調整介面',
      '新增設定: 可修改大頭貼與封面圖片',
      '新增組別設定: 針對各組別可設定是否開放報名',
      '修改圖片選擇器功能',
    ],
  },
  {
    title: 'v1.2.6',
    date: '2019/5/2',
    items: [
      '修改抽獎結果對話框內容: 隱藏得獎者之 Email 與電話',
    ],
  },
  {
    title: 'v1.2.5',
    date: '2019/4/28',
    items: [
      '修改評語之分數欄位為非必填項目',
    ],
  },
  {
    title: 'v1.2.4',
    date: '2019/4/25',
    items: [
      '新增批次晉級表單功能',
    ],
  },
  {
    title: 'v1.2.3',
    date: '2019/4/9',
    items: [
      '新增樂團組與演奏組',
    ],
  },
  {
    title: 'v1.2.2',
    date: '2019/4/1',
    items: [
      '修正報名表單無法正常編輯社會組表單 bug',
    ],
  },
  {
    title: 'v1.2.1',
    date: '2019/3/28',
    items: [
      '修正報名表單選單屆數順序',
    ],
  },
  {
    title: 'v1.2.0',
    date: '2019/3/27',
    items: [
      '新增賽況資訊狀態 [過號] 與 [棄權]',
      '新增賽況資訊批次選取工具',
      '修改賽況資訊編輯器 UI',
    ],
  },
  {
    title: 'v1.1.6',
    date: '2019/3/25',
    items: [
      '修正投票項目學校名稱顯示',
    ],
  },
  {
    title: 'v1.1.5',
    date: '2019/3/21',
    items: [
      '修正人氣投票顯示結果',
    ],
  },
  {
    title: 'v1.1.4',
    date: '2019/3/18',
    items: [
      '修正 Tab 箭頭顯示位置',
      '修正表單顯示椅子數量',
    ],
  },
  {
    title: 'v1.1.3',
    date: '2019/3/14',
    items: [
      '新增設定預告訊息欄位',
      '新增三輪賽制的比賽設定',
    ],
  },
  {
    title: 'v1.1.2',
    date: '2019/3/3',
    items: [
      '修改設定 UI',
      '新增針對僅一輪的比賽設定',
      '新增日期選擇時輔助顯示大約的相對時間',
      '新增快速複製表單文字功能',
      '改進 iOS 瀏覽器視窗的滾動體驗',
    ],
  },
  {
    title: 'v1.1.1',
    date: '2019/2/28',
    items: [
      '調整晉升決賽操作方式',
      '新增報名表單電話欄位格式化顯示',
      '新增報名表單篩選器',
    ],
  },
  {
    title: 'v1.1.0',
    date: '2019/2/24',
    items: [
      '新增組別規則: 可設定針對各組別的設備最大數量與組員上限人數',
      '新增自定義表單欄位功能',
    ],
  },
  {
    title: 'v1.0.3',
    date: '2019/2/21',
    items: [
      '修正 iOS Safari 中編輯表單無法叫出選單問題',
      '修正設定 → 人氣投票欄位',
    ],
  },
  {
    title: 'v1.0.2',
    date: '2019/2/19',
    items: [
      '修正匯出 CSV 功能欄位',
      '新增查看人氣投票結果',
      '新增人氣投票設定值',
    ],
  },
  {
    title: 'v1.0.1',
    date: '2019/2/18',
    items: [
      '新增報名須知欄位',
    ],
  },
]
